<template>
  <div id="container">
    <div
      :class="[isSideBarMenuOpen ? 'containerHeader--menu' : '', 'containerHeader']"
      style="box-shadow: rgb(0 0 0 / 50%) 0 1px 6px 0;"
    >
      <q-tabs
        v-model="tab"
        dense
        class="container-buttons"
        data-cy="container-ambitos"
        active-color="primary"
        indicator-color="primary"
        align="justify"
        style="height: 60%; width: 100%; margin: 0 auto;"
      >
        <q-tab
          v-for="ambito in data"
          v-bind:key="ambito.id"
          :name="ambito.id + '-' + ambito.name"
          :label="ambito.name"
          :class="['col-' + Math.round(12 / data.length), 'supergroup-title']"
        />
      </q-tabs>
      <q-tab-panels v-model="tab" animated>
        <q-tab-panel
          v-for="ambito in data"
          :key="ambito.id"
          :name="ambito.id + '-' + ambito.name"
          style="display: flex; flex-direction: row;"
        >
          <div v-for="tematica in ambito.tematicas" v-bind:key="tematica.id">
            <div class="container-tematicas-header">
              <q-img
                :class="['imgTab', 'imgTabHover']"
                contain
                :src="_getResource(tematica.resources, 'Logotipo')"
                width="64px"
                height="64px"
                @click="scrollToTematica(tematica.id)"
              >
                <q-tooltip
                  content-class="tooltip-tematicas text-weight-bolder text-body1"
                >
                  {{ tematica.name }}
                </q-tooltip>
              </q-img>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>

    <q-tab-panels v-model="tab" animated class="container-tabs col-12">
      <q-tab-panel
        v-for="ambito in data"
        :key="ambito.id"
        :name="ambito.id + '-' + ambito.name"
      >
        <div
          :class="['ltabs', 'col-12', 'row', ambito.id != 0 ? 'espacio' : '']"
          v-for="tematica in ambito.tematicas"
          v-bind:key="tematica.id"
        >
          <q-expansion-item
            class="col-12 expandItem"
            default-opened
            expand-separator
            header-style="padding-left: 0px"
          >
            <template slot="header">
              <div style="display: flex" :id="tematica.id">
                <div class="container-tematica-img">
                  <q-img
                    class="imgTab"
                    contain
                    :src="_getResource(tematica.resources, 'Logotipo')"
                    width="50px"
                    height="50px"
                    style="margin: auto;"
                  />
                </div>
                <span class="textBodyTematica">
                  {{ tematica.name }}
                  <q-img
                    v-if="_getResource(tematica.resources, 'Video') != ''"
                    :src="require('@/assets/img/video-icon.png')"
                    height="24px"
                    width="24px"
                    style="margin-left: 10px"
                    @click.capture.stop="showVideoPopup(tematica)"
                  />

                  <q-img
                    v-if="tematica.url"
                    :src="require('@/assets/img/url-icon.png')"
                    height="24px"
                    width="24px"
                    style="margin-left: 10px"
                    @click.capture.stop="openTematicaUrl(tematica.url)"
                  />
                </span>
              </div>
            </template>
            <template slot="default">
              <div class="row col-12 espacio">
                <div
                  class="espacios col-xl-4 col-lg-4 col-md-6 col-12"
                  v-for="servicio in tematica.servicios"
                  v-bind:key="servicio.id"
                  style="margin-bottom: 20px"
                >
                  <ContenedorServicio :datos="servicio" />
                </div>
              </div>
            </template>
          </q-expansion-item>
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <q-dialog v-model="videoPopup" style="min-width: 550px" :bordered="false">
      <div class="col-12 row">
        <video style="margin: auto;" height="495" controls autoplay muted loop>
          <source :src="videoSelected" />
          Your browser does not support the video tag.
        </video>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Resources from '@/components/shared/mixins/Resources.js';
import ContenedorServicio from './ContenedorServicio.vue';
import { mapGetters } from 'vuex';

import {
  QImg,
  QTabs,
  QTab,
  QTabPanel,
  QTabPanels,
  QTooltip,
  QDialog
} from 'quasar';

export default {
  components: {
    QImg,
    QTabs,
    QTab,
    QTabPanel,
    QTabPanels,
    QTooltip,
    ContenedorServicio,
    QDialog
  },
  mixins: [Message, Resources],
  props: {
    dataCatalogo: Array,
    isLoading: Boolean
  },
  // computed map getter
  computed: {
    ...mapGetters({
      isSideBarMenuOpen: 'PF/isSideBarMenuOpen'
    })
  },
  data () {
    return {
      videoPopup: false,
      videoSelected: null,
      data: this.dataCatalogo,
      tab: '',
      columns: [
        {
          name: 'logo',
          required: true,
          label: 'Logo',
          align: 'center',
          field: row => row.logo
        },
        {
          name: 'name',
          required: true,
          label: 'Nombre',
          align: 'center',
          field: 'name'
        },
        {
          name: 'description',
          required: true,
          label: 'Descripcion',
          align: 'center',
          field: 'description'
        }
      ],
      rows: []
    };
  },
  methods: {
    openTematicaUrl (url) {
      window.open(url, '_blank');
    },
    scrollToTematica (id) {
      const elementContainer = document.querySelector('.dx-drawer-content');
      const element = document.getElementById(id);
      const yOffset = -300;
      const y = element.getBoundingClientRect().top + elementContainer.scrollTop + yOffset;

      elementContainer.scrollTo({ top: y, behavior: 'smooth' }); // Needed with Dinapsis library navbar component
    },
    _getResource (d, search) {
      let resource = this.searchResource(d, search);

      if (resource === null) {
        return this.getDefaultResource(search);
      }

      return resource.url;
    },
    showVideoPopup (tematica) {
      this.videoPopup = true;
      this.videoSelected = this._getResource(tematica.resources, 'Video');
    },
    _setDefault () {
      if (this.data.length > 0) {
        this.tab = this.data[0].id + '-' + this.data[0].name;
      }
    },
    editRow (props) {
      const idApp = props.row.id;

      this.$router.push({ name: 'form_application', params: { idApp: idApp } });
    },
    changeScrollUp () {
      window.scrollTo(0, 0);
    }
  },
  watch: {
    dataCatalogo: {
      handler: function () {
        if (Object.entries(this.dataCatalogo).length > 0) {
          this.data = this.dataCatalogo;

          this._setDefault();
        }
      }
    },
    tab () {
      this.changeScrollUp();
    },
    immediate: true
  }
};
</script>
<style lang="scss" scoped>
.imgTabHover {
  transition: 0.3s;
  margin: 8px;
  &:hover {
    transform: scale(1.2);
  }
}
.textBodyTematica {
  @include tallFont;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.32px;
  height: min-content;
  margin: auto;
  margin-left: 15px;
  color: $dinapsis-marine-blue;
}

.q-tab--active {
  .imgTab {
    transform: scale(1.4) !important;
    filter: grayscale(0%) !important;
  }
  .containervertical-data {
    width: 100%;
  }
}

// Needed to reset wrapper page default
#container {
  margin-left: -79px;
  margin-right: -79px;
  .containerHeader {
    &--menu {
      width: calc(100% - 256px);
      transition: width .5s;
    }
    position: fixed;
    width: 100%;
    background-color: #ffffff;
    z-index: 10;
    height: 180px;
    padding-left: 140px;
    padding-right: 140px;
    padding-bottom: 40px;

    .container-tematicas-header {
      width: 83px;
      height: 83px;
      margin-right: 53px;

      .imgTab {
        cursor: pointer;
      }
    }
  }
  .container-buttons {
    height: 48px;
    color: #002f6c;
    .supergroup-title {
      margin: auto;
      padding: 10px;
    }
    .label-tab {
      opacity: 0.87;
      @include tallFont;
      letter-spacing: -0.15px;
      color: $azulcabecera;
    }
    .containerVertical {
      .containervertical-data {
        display: flex;
        flex-direction: row-reverse;
        padding-bottom: 25px;
        max-height: 100%;
      }
    }
    &:deep() {
      .containerVertical.azulColor .text-primary {
        color: #72c7d7 !important;
      }
      .containerVertical.verdeColor .text-primary {
        color: #8fbe43 !important;
      }
      .containerVertical .q-tab__content {
        width: 100% !important;
      }

      .q-tab__indicator {
        height: 5px;
      }
      .q-tab__label {
        @include tallFont;
        font-size: 25px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        font-size: 18px;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
      }
    }
  }
  .container-tabs {
    padding-top: 180px;
    .container-video {
      background-color: #dddcdb;
      height: 495px;
    }
    .ltabs {
      padding: 0 140px 0 140px;
      &:deep() {
        .q-item {
          padding: 8px 0;
        }
      }
    }
    .icon {
      width: 60px;
      height: 60px;
    }
    .container-textinfo {
      flex-direction: column;
      .title-group {
        @include tallFont;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        font-size: 25px;
        letter-spacing: 0.36px;
        color: $azulcabecera;
      }
      .description-group {
        @include tallFont;
        font-size: 21px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.3px;
        color: $seafoam-blue;
      }
    }
  }

  .q-tab-panels {
    background: transparent !important;
    &:deep() {
      .q-tab-panel {
        // margin-top: 8px;
        padding: 0px !important;
      }
      .q-panel.scroll {
        overflow: hidden;
      }
      .q-expansion-item__toggle-icon {
        font-size: 34px;
        margin-left: 15px;
      }
      .q-expansion-item__toggle-icon--rotated {
        transform: rotate(-90deg);
        margin-left: 15px;
      }

      .expandItem.q-expansion-item--expanded {
        .q-expansion-item__content {
          opacity: 1 !important;
        }
      }

      .expandItem.q-expansion-item--collapsed {
        .q-expansion-item__content {
          opacity: 0 !important;
        }
      }

      .expandItem {
        .q-expansion-item__content {
          transition: height 500ms cubic-bezier(0.25, 0.8, 0.5, 1) 0s,
            opacity 200ms linear !important;
        }
        .container-tematica-img {
          background: white;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          .imgTab {
            border-radius: 50%;
          }
        }
      }
      .expandItem .q-focus-helper {
        background: none !important;
        &:before {
          background: none !important;
        }
      }
    }
  }
}

.espacio {
  margin-top: 50px;
  .espacios {
    padding-bottom: 24px;
    justify-content: space-around;
    padding-right: 24px !important;
  }
}
</style>
